import { useEffect } from "react";
import TagManager from "react-gtm-module";

const GoogleTagManager = () => {
  useEffect(() => {
    const gtmId = "GTM-NKR65NM";

    TagManager.initialize({ gtmId });
  }, []);

  return null; // Não renderiza nada
};

export default GoogleTagManager;
